<template>
  <v-list density="compact" nav :lines="false" class="menu-small sidebaritems-menu" color="var(--primary)">

    <v-list-item v-for="(item, index) in modules" :key="index" @click="updateVisibility(item)">
      <template v-slot:append>
        <v-checkbox hide-details color="var(--primary)" v-model="item.visible"></v-checkbox>
      </template>

      <template v-slot:prepend>
        <div class="menu-icon-left">
          <i :class="`fal ${item.icon}`"></i>
        </div>
      </template>

      <v-list-item-title>{{ item.title }}</v-list-item-title>

    </v-list-item>

  </v-list>
</template>

<script>
export default {
  props: {
    initialSelectedItems: {
      type: Array,
      default: () => [],
    },
    modules: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedItems: this.initialSelectedItems,
    };
  },
  methods: {
    updateVisibility(module) {
      module.visible = !module.visible; // Toggle the visibility
      this.$emit("update:selectedmenuitems", this.selectedItems);
    },
  },
};
</script>

<style>
.sidebaritems-menu .v-checkbox .v-selection-control {
  min-height: unset !important;
}
</style>
